import React, { useContext, useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import useFetch from '../CustomHooks/useFetch';
import { GlobalContext } from '../Contexts/GlobalContext';
import TextField from '@material-ui/core/TextField';
import DefaultLanguageSelector from './MultiLanguage/DefaultLanguageSelector';
import TimeZoneSelector from './MultiLanguage/TimeZoneSelector';
import useGuiTranslations from './MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../Util/StringFunctions';

export default function Logo() {

  const globalContext = useContext(GlobalContext);
  const [putCustomerSettingsHookResponse, putCustomerSettingsHook] = useFetch();
  const [getCustomerSettingsHookResponse, getCustomerSettingsHook] = useFetch();
  const [qrCodeBase64, setQRCodeBase64] = useState();
  const [restaurantName, setRestaurantName] = useState('');
  const [restaurantNameError, setRestaurantNameError] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const classes = useStyles();
  const [language, setLanguage] = useState('en');
  const [timeZone, setTimeZone] = useState('Europe/London');
  const [translateGui] = useGuiTranslations();


  useEffect(
    () => {
      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
      getCustomerSettingsHook(
        {
          url: '/admin/customersettings',
          addTokenHeader: true,
          method: 'GET',
          postData: null,
        }
      )

      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: {
            a: 8,//'Company Info',
            b: 66,//'Settings > Company Info'
          },
        }
      )
    }, []
  )

  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/Logo' });
    }, []
  )

  useEffect(
    () => {
      console.log(getCustomerSettingsHookResponse);

      if (getCustomerSettingsHookResponse.length != 0 && getCustomerSettingsHookResponse) {
        setQRCodeBase64('https://' + getCustomerSettingsHookResponse.logoBase64);

        if (getCustomerSettingsHookResponse.info != null) {
          let info = JSON.parse(getCustomerSettingsHookResponse.info);
          console.log(info);
          if (info.phone != null) {
            setPhone(info.phone)
          }
          if (info.displayName != null) {
            setRestaurantName(info.displayName)
          }
          if (getCustomerSettingsHookResponse.timeZoneId) {
            setTimeZone(getCustomerSettingsHookResponse.timeZoneId);
            console.log(getCustomerSettingsHookResponse.timeZoneId);
          }
          if (getCustomerSettingsHookResponse.defaultLanguage) {
            //setLanguage(getCustomerSettingsHookResponse.langCode);
            setLanguage(getCustomerSettingsHookResponse.defaultLanguage);
          }
        }


      }
      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
    }, [getCustomerSettingsHookResponse]
  )

  const putCustomerSettings = (logoFileBase64, _fileName) => {

    globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });

    putCustomerSettingsHook(
      {
        url: '/admin/customersettings',
        addTokenHeader: true,
        method: 'PUT',
        postData: {
          logoBase64: logoFileBase64,
          logoFileName: _fileName,
          info: {
            phone: phone,
            displayName: restaurantName,
          },
          timeZoneId: timeZone,
          langCode: language,
        },
      }
    )
  }

  useEffect(
    () => {
      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
      if (!Array.isArray(putCustomerSettingsHookResponse)) {
        setQRCodeBase64('https://' + putCustomerSettingsHookResponse.logoBase64);
      }
    }, [putCustomerSettingsHookResponse]
  )

  const handleFile = (e) => {
    console.log(e.target.files);
    if (e.target.files != null && e.target.files[0] != null) {

      var reader = new FileReader();
      reader.fileName = e.target.files[0].name;
      reader.fileType = e.target.files[0].type;

      reader.onload = function (readerEvt) {
        console.log(readerEvt.target);
        var binaryString = readerEvt.target.result;
        let base64String = btoa(binaryString);
        base64String = 'data:' + readerEvt.target.fileType + ';base64, ' + base64String;
        putCustomerSettings(base64String, '', readerEvt.target.fileName);
      };

      reader.readAsBinaryString(e.target.files[0]);
    }
  }


  return (
    <div>
      <Paper elevation={3} className={classes.companyInfoWrapper}>
        <TextField helperText={restaurantNameError} error={restaurantNameError == '' ? false : true} className={classes.textbox} value={restaurantName} onChange={(e) => setRestaurantName(e.target.value)} id="filled-number" label={capitalizeFirstLetter(translateGui(60))} />
        <TextField type="number" helperText={phoneError} error={phoneError == '' ? false : true} className={classes.textbox} value={phone} onChange={(e) => setPhone(e.target.value)} id="filled-number2" label={capitalizeFirstLetter(translateGui(61))} />
        <DefaultLanguageSelector language={language} setLanguage={setLanguage}></DefaultLanguageSelector>
        <TimeZoneSelector timeZone={timeZone} setTimeZone={setTimeZone} ></TimeZoneSelector>
        <Button onClick={() => putCustomerSettings()} color="primary" component="span" variant="contained" style={{ alignSelf: 'flex-end' }}>
          {capitalizeFirstLetter(translateGui(45))}
        </Button>
      </Paper>

      <Paper elevation={3} style={{ padding: '10px', marginBottom: '30px' }}>


        <div style={{ display: 'flex', alignItems: 'center', width: '300px', justifyContent: 'space-between', marginBottom: '10px', }}>
          <span>Logo:</span>
          <img style={{ width: '150px', marginLeft: '15px' }} src={qrCodeBase64}></img>

        </div>
        <div style={{ fontSize: '0.8rem', margin: '10px 0 20px 0' }}> * {capitalizeFirstLetter(translateGui(64))}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="raised-button-file"
            onChange={handleFile}
            type="file"
          />
          <label htmlFor="raised-button-file">
            <Button color="primary" component="span" variant="contained" >
              {capitalizeFirstLetter(translateGui(65))}
            </Button>
          </label>

        </div>
      </Paper>
    </div>
  );
}



const useStyles = makeStyles({
  card: {
    '@media (min-width : 600px)': {
      // width: 'calc(100% - 20px)',
    },
    '& td': {
      //borderBottom : 'none',
      //padding:'0px 24px 0px 16px',
      fontSize: '12px',
    },
    '& th': {
      //padding: '16px 16px 0px 16px',
    },
    '& tbody>tr:not(:last-child):nth-child(2n-1)': {
      //backgroundColor : '#604a0814',  
      //backgroundColor : 'rgb(247, 247, 247)',

    }
  },
  textbox: {
    '& input': {
      //backgroundColor: 'white',
      width: '250px',

    },
  },
  companyInfoWrapper: {
    padding: '10px',
    marginBottom: '30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    '&>div, &>span': {
      marginTop: '15px',
      marginBottom: '15px',
    }
  }
});